import { ChangeDetectionStrategy, Component, model } from "@angular/core";
import { ISelectMenuImports } from "@front/m19-ui";
import {
  BulkUploadPreviewStatus,
  BulkUploadTypeIconComponent,
} from "../bulk-upload-grid-cells/bulk-upload-type-icon.component";
import { TranslocoDirective } from "@jsverse/transloco";

@Component({
  selector: "app-bulk-upload-type-filter",
  imports: [ISelectMenuImports, BulkUploadTypeIconComponent, TranslocoDirective],
  templateUrl: "./bulk-upload-type-filter.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BulkUploadTypeFilterComponent {
  public readonly selectedTypes = model.required<BulkUploadPreviewStatus[]>();

  readonly TYPES = [
    BulkUploadPreviewStatus.CREATION,
    BulkUploadPreviewStatus.UPDATE,
    BulkUploadPreviewStatus.VALUE_ERROR,
    BulkUploadPreviewStatus.UNCHANGED,
  ];

  readonly LABELS_BY_TYPE = {
    [BulkUploadPreviewStatus.CREATION]: "bulk-upload-preview.creations",
    [BulkUploadPreviewStatus.UPDATE]: "bulk-upload-preview.updates",
    [BulkUploadPreviewStatus.VALUE_ERROR]: "bulk-upload-preview.errors",
    [BulkUploadPreviewStatus.UNCHANGED]: "bulk-upload-preview.unchanged",
  };
}
